import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Package } from "@phosphor-icons/react";

// Einstellungen → Integrationen: DHL/Deutsche Post Sendungsverfolgung (Einschreiben)
export default function DhlTrackingPanel() {
  const [st, setSt] = useState(null);
  const [key, setKey] = useState("");
  const [num, setNum] = useState("");
  const [res, setRes] = useState(null);
  const load = () => api.get("/rent-increase/tracking/settings").then(({ data }) => setSt(data)).catch(() => setSt({}));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { await api.put("/rent-increase/tracking/settings", { api_key: key }); setKey(""); load(); toast.success("DHL-API-Key gespeichert"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Speichern fehlgeschlagen"); }
  };
  const test = async () => {
    setRes(null);
    try { const { data } = await api.post("/rent-increase/tracking/test", { tracking_number: num }); setRes(data); }
    catch (e) { toast.error(e?.response?.data?.detail || "Abfrage fehlgeschlagen"); }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4 sm:p-6 shadow-sm space-y-3" data-testid="dhl-tracking-panel">
      <div className="text-sm font-semibold flex items-center gap-2"><Package size={16} /> Sendungsverfolgung (DHL / Deutsche Post)</div>
      <p className="text-xs text-slate-600">
        Für Einschreiben (Einwurf, Übergabe, Rückschein, Eigenhändig). Kostenlosen Key auf developer.dhl.com anlegen
        (App → „Shipment Tracking – Unified“) und hier eintragen. Zugestellte Sendungen setzen das Zugangsdatum automatisch.
      </p>
      <div className="text-xs" data-testid="dhl-tracking-status">
        Status: {st?.configured ? <span className="text-emerald-700 font-medium">verbunden ({st.hint})</span> : <span className="text-amber-700">kein Key hinterlegt</span>}
      </div>
      <div className="flex gap-2">
        <Input type="password" placeholder="DHL-API-Key (Consumer Key)" value={key} onChange={(e) => setKey(e.target.value)} className="max-w-sm" data-testid="dhl-tracking-key" />
        <Button size="sm" onClick={save} disabled={!key.trim()} data-testid="dhl-tracking-save">Speichern</Button>
      </div>
      {st?.configured && (
        <div className="flex gap-2 items-center flex-wrap">
          <Input placeholder="Sendungsnummer testen, z. B. RR123456789DE" value={num} onChange={(e) => setNum(e.target.value)} className="max-w-sm" data-testid="dhl-tracking-test-number" />
          <Button size="sm" variant="outline" onClick={test} disabled={!num.trim()} data-testid="dhl-tracking-test">Abfragen</Button>
          {res && <span className="text-xs" data-testid="dhl-tracking-test-result">{res.not_found ? "Keine Daten gefunden" : `${res.status_text || res.status_code}${res.delivered_at ? ` · zugestellt ${new Date(res.delivered_at).toLocaleString("de-DE")}` : ""}`}</span>}
        </div>
      )}
    </div>
  );
}
